module.exports = __webpack_public_path__ + "img/TrimbleIcon.0117593e.jpeg";